module.exports = __webpack_public_path__ + "static/img/main-navigation-icon02.73f6d273.svg";